import { BackButton } from "./back-button"

export function Header({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <>
      <div className="h-header shrink-0" aria-hidden />
      <header className="fixed top-[var(--offline-banner-h,0px)] inset-x-0 min-h-header flex items-center py-s bg-card border-b shadow-sm z-50 border-primary/20">
        <BackButton />
        <div className={`pr-m min-w-0 w-full flex items-center gap-m ${className}`}>{children}</div>
      </header>
    </>
  )
}
